module.exports = __webpack_public_path__ + "767aa062d9b5419571439e60598bc78d.svg";